import { Get } from 'services';
import { ApiPath } from 'paths';

export const getProfile = async () => {
  const res = await Get(`${ApiPath.PROFILE}`, {
    accessTokenV3: true,
  });
  return res.data;
};
